import { NatObjectItemController } from "@natiwi/core/controllers/object-item.controller";
import { OrmCustomerOrderContactItem } from "@natiwi/shared/models/customer-order.model";

export class NatCustomerOrderContactItemController extends NatObjectItemController<OrmCustomerOrderContactItem>{

    constructor() {
        super();
        super.registerDataClass(OrmCustomerOrderContactItem);
    }
}